export const DEFAULT_SPECS_PAGE_SIZE = 5;
